var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1187",
    "data-name": "Grupo 1187",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.664,
    height: 19,
    viewBox: "0 0 26.664 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1798",
    "data-name": "Trazado 1798",
    d: "M24.956,29.68H5.867A3.792,3.792,0,0,1,2.08,25.892V14.467A3.792,3.792,0,0,1,5.867,10.68H24.956a3.792,3.792,0,0,1,3.787,3.787V25.892a3.792,3.792,0,0,1-3.787,3.787ZM5.867,12.017a2.451,2.451,0,0,0-2.451,2.451V25.892a2.451,2.451,0,0,0,2.451,2.451H24.956a2.451,2.451,0,0,0,2.451-2.451V14.467a2.451,2.451,0,0,0-2.451-2.451Z",
    transform: "translate(-2.08 -10.68)",
    fill: "#e73758"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1799",
    "data-name": "Trazado 1799",
    d: "M15.856,25.829a3.792,3.792,0,0,1-2.286-.762L3.166,17.2a.668.668,0,1,1,.807-1.065l10.4,7.878a2.473,2.473,0,0,0,2.959,0l10.4-7.878a.668.668,0,1,1,.807,1.065l-10.4,7.869a3.792,3.792,0,0,1-2.286.762Z",
    transform: "translate(-2.524 -13.62)",
    fill: "#e73758"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1800",
    "data-name": "Trazado 1800",
    d: "M3.337,38.378a.668.668,0,0,1-.446-1.167l8.2-7.312a.669.669,0,0,1,.891,1l-8.2,7.312A.651.651,0,0,1,3.337,38.378Zm24.8,0a.651.651,0,0,1-.446-.169l-8.2-7.312a.669.669,0,0,1,.891-1l8.194,7.312a.668.668,0,0,1-.446,1.167Z",
    transform: "translate(-2.406 -21.241)",
    fill: "#e73758"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.77fd1311f4cd07c3af57f2399504e9a0.svg";
export { ForwardRef as ReactComponent };